<div class="p-4 my-4 border-gray-400 border-dashed border rounded-md">
  <p class="mb-3 text-xl">
    <b>{{ title }}</b>
  </p>
  <div class="radio-button-container">
    <div class="grid grid-cols-12 gap-4">
      @for (item of options; track $index) {
      <div class="lg:col-span-4 md:col-span-6 sm:col-span-12 col-span-12">
        <div class="radio-button">
          <input
            #radioButton
            type="radio"
            class="radio-button__input"
            id="{{ item.id }}"
            [value]="item"
            [(ngModel)]="option"
            [name]="name"
            (change)="getItem(item)"
          />
          <label class="radio-button__label text-sm" for="{{ item.id }}">
            <span class="radio-button__custom"></span>
            {{
              optionLabel
                ? item[optionLabel]
                  ? item[optionLabel]
                  : 'No se encontró la propiedad ' + optionLabel
                : item
            }}
          </label>
        </div>
      </div>
      } @empty {
      <div class="col-span-12">
        <p class="text-center"><cite>No hay opciones disponibles</cite></p>
      </div>
      }
    </div>
  </div>
  <div class="hide" [ngClass]="{ show: option() }">
    <div class="flex justify-end">
      <petrol-button variant="tertiary" (click)="clearSelection()">Limpiar selección</petrol-button>
    </div>
  </div>
</div>
